import React from "react";

import "./style.css";

export const ListCard = ({ children }) => {
  return <div className={"list_card__wrapper"}>{children}</div>;
};
